<template>
    <div class="leaderboards">
        <!--img alt="Vue logo" src="../assets/logo.png"-->
        <LeaderboardUsers :all="true" :title="'Alle Läufer'" />
    </div>
</template>

<script>
    // @ is an alias to /src
    import LeaderboardUsers from '@/components/leaderboards/LeaderboardUsers.vue';

    export default {
        name: 'UsersList',
        components: {
            LeaderboardUsers,
        }
    }
</script>
